import './cateringcreations2/style';
import FormStructure from './cateringcreations2/form_structure';

export default FormStructure;